import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Title, Subtitle, Col, ButtonSubmit } from '../../../styles';

const WorkstationApprovedSuccess = ({ onLogin }) => {
  const [t] = useTranslation('login');

  return (
    <Col>
      <Title>{t('workstation.approved.title')}</Title>
      <Subtitle>{t('workstation.approved.subtitle')}</Subtitle>
      <ButtonSubmit block color="primary" onClick={onLogin}>
        {t('workstation.approved.cta')}
      </ButtonSubmit>
    </Col>
  );
};

export default WorkstationApprovedSuccess;

WorkstationApprovedSuccess.propTypes = {
  onLogin: propTypes.func.isRequired,
};
